import React from "react";
import { Col, Container, Row } from "reactstrap";

const TermsAndConditions = () => {
  return (
    <section id="terms-and-conditions" className="accordion-flush">
      <Container>
        <Row>
          <Col lg="12" xs="12" className="mb-10">
            <div className="course__top d-flex justify-content-between align-items-center flex-wrap">
              <div className="course__top__left w-60">
                <h2>Terms And Conditions</h2>

                <h3>Last Updated: September 28, 2023</h3>
              </div>

              <div className="w-50 text-end">
                {/* <button className="btn">See All</button>  */}
              </div>
            </div>
          </Col>
          <Col lg="8" md="12" sm="12">
            <p>
              Please read these Terms and Conditions carefully before using the
              Seed to Tree Online Academy website. By accessing or using our
              website and services, you agree to abide by these terms and
              conditions.
            </p>
            <p>
              By using Seed to Tree Online Academy's website and services, you
              agree to comply with these Terms and Conditions. Thank you for
              your cooperation.
            </p>
          </Col>
          <Col lg="12" md="12" sm="12">
            <div className="accordion accordion-flush">
              {/* 1 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    <h3>1. Acceptance of Terms</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    <h4>1.1 Agreement</h4>
                    <p>
                      By accessing or using the Seed to Tree Online Academy
                      website, you agree to be bound by these Terms and
                      Conditions. If you do not agree with these terms, please
                      do not use our website.
                    </p>
                    <h4>1.2 Updates</h4>
                    <p>
                      We may update these Terms and Conditions from time to
                      time. Any changes will be effective upon posting on the
                      website. It is your responsibility to review these terms
                      periodically for updates.
                    </p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                    <h3>2. Use of the Website</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    <h4>2.1 Eligibility</h4>
                    <p>
                      You must be at least 13 years of age to use our website.
                      If you are under 18, you may use our website and services
                      only with the involvement and consent of a parent or legal
                      guardian.
                    </p>
                    <h4> 2.2 User Account</h4>
                    <p>
                      To access certain features of our website, you may be
                      required to register for an account. You are responsible
                      for maintaining the confidentiality of your account
                      information and for all activities that occur under your
                      account.
                    </p>
                    <h4>2.3 Prohibited Activities</h4>
                    <div>
                      You agree not to:
                      <ol>
                        <li>
                          Use our website for any unlawful or prohibited
                          purpose.
                        </li>
                        <li>
                          Upload, post, or transmit any content that is harmful,
                          offensive, or violates the rights of others.
                        </li>
                        <li>
                          Attempt to gain unauthorized access to our website,
                          systems, or networks.
                        </li>
                        <li>
                          Interfere with the security or integrity of our
                          website.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              {/* 3 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
                    <h3>3. Intellectual Property</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    <h4>3.1 Ownership</h4>
                    <p>
                      All content on the Seed to Tree Online Academy website,
                      including text, graphics, logos, and images, is the
                      property of Seed to Tree Online Academy and is protected
                      by copyright and other intellectual property laws.
                    </p>

                    <h4>3.2 Limited License</h4>
                    <p>
                      You are granted a limited, non-exclusive, and
                      non-transferable license to access and use our website for
                      personal, non-commercial purposes.
                    </p>
                  </div>
                </div>
              </div>
              {/* 4 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour"
                    aria-expanded="false"
                    aria-controls="flush-collapseFour"
                  >
                    <h3>4. Privacy</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      Your use of our website is governed by our Privacy Policy,
                      which outlines how we collect, use, and protect your
                      personal information.
                    </p>
                  </div>
                </div>
              </div>
              {/* 5. Third-Party Links */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFive"
                    aria-expanded="false"
                    aria-controls="flush-collapseFive"
                  >
                    <h3>5. Third-Party Links</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseFive"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      Our website may contain links to third-party websites. We
                      are not responsible for the content or privacy practices
                      of these external sites. Use them at your own risk.
                    </p>
                  </div>
                </div>
              </div>
              {/* 6. Disclaimer and Limitations */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSix"
                    aria-expanded="false"
                    aria-controls="flush-collapseSix"
                  >
                    <h3>6. Disclaimers and Limitation of Liability</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseSix"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    <h4>6.1 Content Accuracy</h4>
                    <p>
                      We make every effort to ensure the accuracy and quality of
                      the content on our website. However, we do not guarantee
                      that the information is error-free or up-to-date.
                    </p>
                    <h4>6.2 No Warranty</h4>
                    <p>
                      Our website and services are provided "as is" and "as
                      available" without any warranties, express or implied.
                    </p>
                    <h4>6.3 Limitation of Liability</h4>
                    <p>
                      Seed to Tree Online Academy and its affiliates will not be
                      liable for any direct, indirect, incidental,
                      consequential, or punitive damages arising from your use
                      of the website.
                    </p>
                  </div>
                </div>
              </div>
              {/* 7. Termination */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSeven"
                    aria-expanded="false"
                    aria-controls="flush-collapseSeven"
                  >
                    <h3>7. Termination</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseSeven"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      We reserve the right to terminate or suspend your account
                      and access to our website at our discretion, without prior
                      notice, for any reason, including a breach of these Terms
                      and Conditions.
                    </p>
                  </div>
                </div>
              </div>
              {/* 8. Governing Law */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseEight"
                    aria-expanded="false"
                    aria-controls="flush-collapseEight"
                  >
                    <h3>8. Governing Law</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseEight"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      These Terms and Conditions are governed by and construed
                      in accordance with the laws of [Your Jurisdiction]. Any
                      disputes arising from these terms will be subject to the
                      exclusive jurisdiction of the courts in [Your
                      Jurisdiction].
                    </p>
                  </div>
                </div>
              </div>
              {/* 9. Contact Us */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseNine"
                    aria-expanded="false"
                    aria-controls="flush-collapseNine"
                  >
                    <h3>9. Contact Us</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseNine"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      If you have any questions or concerns regarding these
                      Terms and Conditions, please contact us at
                      seedtotree.info@gmail.com
                    </p>{" "}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TermsAndConditions;
